export const URL_PATTERN =
  /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,15}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/;

export const PATH_PATTERN = /^[-a-zA-Z0-9%_+.~#?&//=]+$/;

export const URL_AND_MAILTO_PATTERN =
  /(^mailto:(?!.*\.\.)[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)|(^https?:\/\/(?!.*\.\.)[-a-zA-Z0-9_]+\.[a-zA-Z0-9-.]+[^ ]*$)/;
